module.exports = headerImageUrl => {
  return `<mj-section css-class="header-image">
    <mj-column>
      <mj-image href="{{defaults @root.company.domain.domain 'http://localhost:8080'}}" src="${headerImageUrl}" />
    </mj-column>
  </mj-section>`;
};



// WEBPACK FOOTER //
// ./src/emails/components/headerImage.js